import React, {useState} from 'react'
import {
    CButton,
    CCol,
    CContainer, CFormCheck,
    CFormInput, CFormSelect, CLoadingButton
} from "@coreui/react-pro";
import ShowLoading from "../../components/ShowLoading";
import TextEditor from "../../components/TextEditor";
import {FiSave} from "react-icons/fi";
import {SiMicrosoftexcel} from "react-icons/si";
import {BsCloudUpload} from "react-icons/bs";
import PostTest from "../../components/test/PostTest";
import UploadTest from "../../components/test/UploadTest";
import Table from "../../components/tables/table";
import SponsorshipAnalysisPage from "./dashboard/SkillReports/SponsorshipAnalysisPage";

const Sponsorship = () => {
    const [isAnalysisVisible, setIsAnalysisVisible] = useState(false)
    const [userTestData, setUserTestData] = useState(null)
    const handleSelectUser = (data) => {
        setUserTestData(data)
        setIsAnalysisVisible(true)
    }
    const headers = [
        {name: "Applicants", sort: true},
        {name: "Scholarship Type", sort:true},
        {name: "CV/Resume", sort: true},
        {name: "Financial Statement",sort:true},
        {name: "Letter of Recommendation", sort: true},
        {name: "Action"}]
    const items = [
        {name:"Peter Emmanuel", scholarshipType: "Nil", cv:"Uploaded", financialStatement:"Uploaded", letterRecommendation:"Uploaded"},
        {name:"Peter Emmanuel", scholarshipType: "Nil", cv:"Uploaded", financialStatement:"Uploaded", letterRecommendation:"Uploaded"},
        {name:"Peter Emmanuel", scholarshipType: "Nil", cv:"Uploaded", financialStatement:"Uploaded", letterRecommendation:"Uploaded"},
        {name:"Peter Emmanuel", scholarshipType: "Nil", cv:"Uploaded", financialStatement:"Uploaded", letterRecommendation:"Uploaded"},
    ]

    return (
        <>
            {!isAnalysisVisible ?
                <CContainer className="mt-4">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <h5 className="text-2 mb-3 ps-1">List of Sponsorship Applicants</h5>
                </div>
                <Table headers={headers}>
                    {items?.map((item, index) => (
                        <tr className="cursor-pointer bg-white border"
                            key={index}
                            onClick={() => setIsAnalysisVisible(true)}
                        >
                            <td className="td-single-line fw-medium">{item?.name}</td>
                            <td className="fw-medium">{item?.scholarshipType}</td>
                            <td className="fw-medium">{item?.cv}</td>
                            <td className="fw-medium">{item?.financialStatement}</td>
                            <td className="fw-medium">{item?.letterRecommendation}</td>
                            <td className="fw-medium">view</td>
                        </tr>
                    ))}
                </Table>
            </CContainer>:
                <CContainer className="mt-4">

                    <SponsorshipAnalysisPage
                        userData={userTestData}
                        setIsAnalysisVisible={setIsAnalysisVisible}
                    />
                </CContainer>
            }
        </>
    )
}

export default Sponsorship
